import { createAction, props } from '@ngrx/store';

import { type CanvasElementId } from '@blaze-runtime/engine-domain';
import { type NavMenu } from '@blaze-shared/elements-domain';

import { type NavMenuDirection } from '../../elements/nav-menu/nav-menu.models';

const TAG = '[Nav menu]';

export const itemsLoaded = createAction(
  `${TAG} Items loaded`,
  props<{ items: NavMenu.LegacySharedItem[] }>(),
);

export const addLocalItem = createAction(
  `${TAG} Add local item`,
  props<{ placement: NavMenu.Placement; itemType: NavMenu.ItemType }>(),
);

export const requestAddSharedItem = createAction(
  `${TAG} Request add shared item`,
  props<{ placement: NavMenu.Placement }>(),
);

export const addSharedItem = createAction(
  `${TAG} Add shared item`,
  props<{
    namespaceId: string;
    placement: NavMenu.Placement;
    initialData?: Partial<NavMenu.ItemProps>;
  }>(),
);

export const editItemByPath = createAction(
  `${TAG} Edit item by path`,
  props<{
    id: string;
    propName: keyof NavMenu.ItemProps;
    value: any;
  }>(),
);

export const requestDeleteItem = createAction(
  `${TAG} Request delete item`,
  props<{ id: string; elementId?: CanvasElementId }>(),
);

export const deleteItem = createAction(`${TAG} Delete item`, props<{ id: string }>());

export const removeSection = createAction(
  `${TAG} Remove section`,
  props<{ id: string; elementId: string }>(),
);

export const requestInitItems = createAction(
  `${TAG} Request initialize items`,
  props<{ placement: NavMenu.Placement }>(),
);

export const initItems = createAction(
  `${TAG} Initialize items`,
  props<{
    namespaceId: string;
    placement: NavMenu.Placement;
  }>(),
);

export const markItemAsDirty = createAction(`${TAG} Mark item as dirty`, props<{ id: string }>());

export const moveItem = createAction(
  `${TAG} Move item`,
  props<{
    elementId: CanvasElementId;
    dragRef: NavMenu.RefIds;
    targetRef: NavMenu.RefIds;
    direction: NavMenu.DropDirection;
  }>(),
);

export const openPropsFloatingPanelAfterAddingItem = createAction(
  `${TAG} Open props floating panel after adding item`,
  props<{
    elementId: CanvasElementId;
    itemId: string;
  }>(),
);

export const cleanLastAdded = createAction(`${TAG} Clean last added`);

export const requestChangeMenuDirection = createAction(
  `${TAG} Request change menu direction`,
  props<{ elementId: CanvasElementId; direction: NavMenuDirection }>(),
);

export const changeMenuDirection = createAction(
  `${TAG} Change menu direction`,
  props<{ elementId: CanvasElementId; direction: NavMenuDirection }>(),
);
